/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Recovery_TiredInputs */

const en_us2_native_release_widget_recovery_tired = /** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still recovering`)
};

const pt_br2_native_release_widget_recovery_tired = /** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda se recuperando`)
};

const pt_pt2_native_release_widget_recovery_tired = /** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda se recuperando`)
};

/** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */
const es_419_native_release_widget_recovery_tired = en_us2_native_release_widget_recovery_tired;

/** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */
const fr_fr2_native_release_widget_recovery_tired = en_us2_native_release_widget_recovery_tired;

/** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */
const de_de2_native_release_widget_recovery_tired = en_us2_native_release_widget_recovery_tired;

/** @type {(inputs: Native_Release_Widget_Recovery_TiredInputs) => LocalizedString} */
const it_it2_native_release_widget_recovery_tired = en_us2_native_release_widget_recovery_tired;

/**
* | output |
* | --- |
* | "Still recovering" |
*
* @param {Native_Release_Widget_Recovery_TiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_recovery_tired = /** @type {((inputs?: Native_Release_Widget_Recovery_TiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Recovery_TiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_recovery_tired(inputs)
	if (locale === "es-419") return es_419_native_release_widget_recovery_tired(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_recovery_tired(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_recovery_tired(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_recovery_tired(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_recovery_tired(inputs)
	return en_us2_native_release_widget_recovery_tired(inputs)
});
export { native_release_widget_recovery_tired as "native-release.widget_recovery_tired" }